import { render, staticRenderFns } from "./ServicesReservationsTable.vue?vue&type=template&id=ffefae5a&"
import script from "./ServicesReservationsTable.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports